import {Serializer, Serializers} from "../../interfaces/serializer";
import {DataSource} from "../../interfaces/data-source";
import {DatasetUsageComponentObjects} from '../../classes/dataset-usage-component-object';

export const DATA_SOURCES_USAGES_STATE_NAME = 'dataSourcesUsages';

export interface DataSourcesUsagesState {
  serialized: Serializers<DataSource>;
  componentObjects: DatasetUsageComponentObjects;
  paid: Serializers<DataSource>;
  ads: Serializers<DataSource>;
  sites: Serializers<DataSource>;
  attribution: Serializer<DataSource>;
  loading: boolean;
  loaded: boolean;
  initialized: boolean;
}
